import { render, staticRenderFns } from "./prestataire2.vue?vue&type=template&id=5efe72f6&"
import script from "./prestataire2.vue?vue&type=script&lang=js&"
export * from "./prestataire2.vue?vue&type=script&lang=js&"
import style0 from "./prestataire2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports